import React from "react";

const dummyImageUrl = `${EASYCOMMERCE.assets}admin/img/icons/demo-image.png`;

const ItemsTable = ({ order }) => {
    return (
        <table className="w-full border-0 m-0">
            <thead>
                <tr className="easycommerce-dashboard-order-iteam-wrap grid grid-cols-12 gap-0">
                    <th className="col-span-8 font-inter font-semibold text-base md:text-xl text-left leading-8 text-ec-body p-0 pl-4 pb-6 border-0 border-b border-ec-border">
                        Items
                    </th>
                    <th className="col-span-2 font-inter font-semibold text-base md:text-xl text-right leading-8 text-ec-body p-0 pb-6 border-0 border-b border-ec-border">
                        Quantity
                    </th>
                    <th className="col-span-2 font-inter font-semibold text-base md:text-xl text-right leading-8 text-ec-body p-0 pr-4 pb-6 border-0 border-b border-ec-border">
                        Total
                    </th>
                </tr>
            </thead>

            <tbody>
                {order.items.map((item, index) => (
                    <tr key={index} className="grid grid-cols-12 gap-0 p-0">
                        {item.product && item.product.name ? (
                            <td
                                className={`col-span-8 p-0 pl-4 border-0 ${
                                    index === 0 ? "pt-5" : ""
                                } ${
                                    index === order.items.length - 1
                                        ? "pt-[10px] pb-5 border-b border-ec-border"
                                        : "pb-[10px]"
                                }`}
                            >
                                <span className="flex justify-start items-start gap-7">
                                    <span className="w-[80px] h-[80px]">
                                        <img
                                            src={
                                                item.product.thumbnail.url ||
                                                dummyImageUrl
                                            }
                                            alt={item.product.name}
                                            className="w-full h-full rounded pointer-events-none"
                                        />
                                    </span>
                                    <span className="flex flex-col gap-3">
                                        <span className="font-inter font-medium text-base leading-[26px] text-ec-body">
                                            {item.product.name}
                                        </span>
                                        <span className="font-inter text-sm text-ec-body">
                                            {item.variation.name}
                                        </span>
                                        <span className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                                            {item.rate}
                                        </span>
                                    </span>
                                </span>
                            </td>
                        ) : (
                            <td className="col-span-8 border-0 border-b border-ec-border"></td>
                        )}

                        {item.quantity ? (
                            <td
                                className={`col-span-2 flex justify-end items-center text-right p-0 border-0 ${
                                    index === 0 ? "pt-5" : ""
                                } ${
                                    index === order.items.length - 1
                                        ? "pt-[10px] pb-5 border-b border-ec-border"
                                        : "pb-[10px]"
                                }`}
                            >
                                <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                    &times;{item.quantity}
                                </span>
                            </td>
                        ) : (
                            <td className="col-span-2 border-0 border-b border-ec-border"></td>
                        )}

                        {item.price ? (
                            <td
                                className={`col-span-2 flex justify-end items-center text-right p-0 pr-4 border-0 ${
                                    index === 0 ? "pt-5" : ""
                                } ${
                                    index === order.items.length - 1
                                        ? "pt-[10px] pb-5 border-b border-ec-border"
                                        : "pb-[10px]"
                                }`}
                            >
                                <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                    {item.price}
                                </span>
                            </td>
                        ) : (
                            <td className="col-span-2 border-0 border-b border-ec-border"></td>
                        )}
                    </tr>
                ))}

                {order.subtotal ? (
                    <tr className="grid grid-cols-12 gap-0 p-0">
                        <td className="col-span-8 p-0 pt-4 pb-[10px] pl-4 text-left border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                Subtotal
                            </span>
                        </td>
                        <td className="col-span-2 p-0 pt-4 pb-[10px] border-0"></td>
                        <td className="col-span-2 p-0 pt-4 pb-[10px] pr-4 text-right border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-body">
                                {order.subtotal}
                            </span>
                        </td>
                    </tr>
                ) : null}

                {order.discount ? (
                    <tr className="grid grid-cols-12 gap-0 p-0">
                        <td className="col-span-8 p-0 py-[10px] pl-4 text-left border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                Discount
                            </span>
                        </td>
                        <td className="col-span-2 p-0 py-[10px] border-0"></td>
                        <td className="col-span-2 p-0 py-[10px] pr-4 text-right border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                {order.discount}
                            </span>
                        </td>
                    </tr>
                ) : null}

                {order.shipping ? (
                    <tr className="grid grid-cols-12 gap-0 p-0">
                        <td className="col-span-8 p-0 py-[10px] pl-4 text-left border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                Shipping
                            </span>
                        </td>
                        <td className="col-span-2 p-0 py-[10px] border-0"></td>
                        <td className="col-span-2 p-0 py-[10px] pr-4 text-right border-0">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-body">
                                {order.shipping}
                            </span>
                        </td>
                    </tr>
                ) : null}

                {order.tax ? (
                    <tr className="grid grid-cols-12 gap-0 p-0">
                        <td className="col-span-8 p-0 pt-[10px] pb-4 pl-4 text-left border-0 border-b border-ec-border">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-placeholder">
                                Tax
                            </span>
                        </td>
                        <td className="col-span-2 p-0 pt-[10px] pb-4 border-0 border-b border-ec-border"></td>
                        <td className="col-span-2 p-0 pt-[10px] pb-4 pr-4 text-right border-0 border-b border-ec-border">
                            <span className="font-inter font-medium text-base leading-[26px] text-ec-body">
                                {order.tax}
                            </span>
                        </td>
                    </tr>
                ) : null}
            </tbody>

            <tfoot>
                <tr className="grid grid-cols-12 gap-0 p-0">
                    <td className="col-span-8 p-0 pt-5 pl-4 text-left border-0">
                        <span className="font-inter font-bold text-base leading-[26px] text-ec-body">
                            Total
                        </span>
                    </td>
                    <td className="col-span-2 p-0 pt-5 border-0"></td>
                    <td className="col-span-2 p-0 pt-5 pr-4 text-right border-0">
                        <span className="font-inter font-semibold text-base leading-[26px] text-ec-body">
                            {order.total}
                        </span>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

export default ItemsTable;
